const now = new Date();
const minutesAgo = (mins) => new Date(now.getTime() - mins * 60000).toISOString();
const hoursAgo = (hrs) => new Date(now.getTime() - hrs * 3600000).toISOString();
const daysAgo = (days) => new Date(now.getTime() - days * 86400000).toISOString();

export const mockNotificationsData = [
  // ===== UNREAD NOTIFICATIONS (is_read: 0) =====

  // -- Appointments --
  {
    id: 1,
    type: 'appointment',
    title: 'New Appointment Booked',
    description: 'Aryan Sharma booked Speech Therapy with Dr Neha \u2022 Today 10:30 AM',
    user_id: null,
    reference_id: 101,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(2),
  },
  {
    id: 13,
    type: 'appointment',
    title: 'Appointment Rescheduled',
    description: 'Kavya Nair rescheduled Physiotherapy from 3:00 PM to 5:00 PM \u2022 Tomorrow',
    user_id: null,
    reference_id: 105,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(5),
  },
  {
    id: 14,
    type: 'appointment',
    title: 'Emergency Walk-in',
    description: 'Rohan Mehta arrived as walk-in for Speech Therapy \u2022 No slot assigned',
    user_id: null,
    reference_id: 106,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'high',
    is_read: 0,
    action_type: 'assign_slot',
    action_data: { patient_id: 106, patient_name: 'Rohan Mehta' },
    clinic_id: 1,
    created_at: minutesAgo(8),
  },
  {
    id: 15,
    type: 'appointment',
    title: 'Double Booking Detected',
    description: 'Dr Neha has 2 appointments at 11:00 AM tomorrow \u2022 Conflict needs resolution',
    user_id: null,
    reference_id: 107,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'critical',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(10),
  },
  {
    id: 16,
    type: 'appointment',
    title: 'Patient Running Late',
    description: 'Priya Reddy informed 15 min delay for OT session \u2022 Today 2:00 PM',
    user_id: null,
    reference_id: 108,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(12),
  },
  {
    id: 17,
    type: 'appointment',
    title: 'Session Extended',
    description: 'Ankit Kumar\u2019s Physiotherapy session extended by 15 mins \u2022 Room 2',
    user_id: null,
    reference_id: 109,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(18),
  },

  // -- Payments --
  {
    id: 2,
    type: 'payment',
    title: '\u20B95,000 Payment Received',
    description: 'Aryan Sharma \u2022 Speech Therapy',
    user_id: null,
    reference_id: 201,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(15),
  },
  {
    id: 18,
    type: 'payment',
    title: '\u20B912,000 Payment Received',
    description: 'Kavya Nair \u2022 Monthly Physiotherapy Package',
    user_id: null,
    reference_id: 204,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(20),
  },
  {
    id: 19,
    type: 'payment',
    title: 'Payment Failed',
    description: 'Online payment of \u20B98,000 from Rohan Mehta failed \u2022 Retry needed',
    user_id: null,
    reference_id: 205,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(25),
  },
  {
    id: 20,
    type: 'payment',
    title: 'Invoice Overdue - 7 Days',
    description: '\u20B915,000 pending from Meera Gupta \u2022 Special Education package \u2022 Due 7 days ago',
    user_id: null,
    reference_id: 206,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'critical',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(28),
  },
  {
    id: 21,
    type: 'payment',
    title: 'Refund Requested',
    description: 'Priya Reddy requested refund of \u20B93,500 \u2022 Cancelled OT sessions',
    user_id: null,
    reference_id: 207,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(35),
  },

  // -- Waiting List --
  {
    id: 3,
    type: 'waiting_list',
    title: 'Slot Available',
    description: 'Speech Therapy slot for Aryan Sharma from waiting list',
    user_id: null,
    reference_id: 301,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'high',
    is_read: 0,
    action_type: 'assign_slot',
    action_data: { waiting_list_id: 301, patient_name: 'Aryan Sharma' },
    clinic_id: 1,
    created_at: minutesAgo(30),
  },
  {
    id: 22,
    type: 'waiting_list',
    title: 'Slot Available',
    description: 'OT slot opened for Siddharth Joshi \u2022 Thursday 4:00 PM',
    user_id: null,
    reference_id: 302,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'high',
    is_read: 0,
    action_type: 'assign_slot',
    action_data: { waiting_list_id: 302, patient_name: 'Siddharth Joshi' },
    clinic_id: 1,
    created_at: minutesAgo(40),
  },
  {
    id: 23,
    type: 'waiting_list',
    title: 'New Patient Added to Waiting List',
    description: 'Tanvi Deshmukh added to Physiotherapy waiting list \u2022 Priority: Urgent',
    user_id: null,
    reference_id: 303,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(45),
  },
  {
    id: 24,
    type: 'waiting_list',
    title: 'Long Wait Alert',
    description: 'Aarav Kulkarni waiting for 14 days \u2022 Speech Therapy \u2022 No slot available yet',
    user_id: null,
    reference_id: 304,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'critical',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: minutesAgo(50),
  },

  // -- Clinical --
  {
    id: 4,
    type: 'clinical',
    title: 'Dropout Risk',
    description: 'Sneha Verma missed 3 sessions \u2022 High dropout risk',
    user_id: null,
    reference_id: 401,
    reference_type: 'patient',
    link: '/portal/predictive-intelligence',
    priority: 'critical',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(1),
  },
  {
    id: 25,
    type: 'clinical',
    title: 'Goal Achieved',
    description: 'Kavya Nair achieved "Independent Walking" goal \u2022 Physiotherapy milestone',
    user_id: null,
    reference_id: 403,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(1.5),
  },
  {
    id: 26,
    type: 'clinical',
    title: 'Therapy Stagnation Detected',
    description: 'Rohan Mehta \u2022 Speech Therapy progress stagnant for 4 weeks \u2022 Review recommended',
    user_id: null,
    reference_id: 404,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(2),
  },
  {
    id: 27,
    type: 'clinical',
    title: 'Assessment Due',
    description: 'Siddharth Joshi \u2022 Quarterly OT assessment overdue by 5 days',
    user_id: null,
    reference_id: 405,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(2.5),
  },
  {
    id: 28,
    type: 'clinical',
    title: 'New Diagnosis Added',
    description: 'Dr Neha added ADHD diagnosis for Tanvi Deshmukh',
    user_id: null,
    reference_id: 406,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(3),
  },

  // -- Attendance --
  {
    id: 51,
    type: 'attendance',
    title: 'Attendance Change Needs Approval',
    description: 'Deepak Yadav\u2019s attendance for 2026-08-10: Present \u2192 Absent',
    user_id: null,
    reference_id: 901,
    reference_type: 'staff_attendance_request',
    link: '/portal/attendance',
    priority: 'high',
    is_read: 0,
    action_type: 'attendance_change_approval',
    action_data: {
      requestId: 901,
      userId: 507,
      staffName: 'Deepak Yadav',
      date: '2026-08-10',
      previousStatus: 'Yes',
      requestedStatus: 'No',
    },
    clinic_id: 1,
    created_at: minutesAgo(12),
  },
  {
    id: 52,
    type: 'attendance',
    title: 'Attendance Change Approved',
    description: 'Your attendance change for Deepak Yadav on 2026-08-08 was approved.',
    user_id: null,
    reference_id: 899,
    reference_type: 'staff_attendance_request',
    link: '/portal/attendance',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(2),
  },

  // -- Staff --
  {
    id: 5,
    type: 'staff',
    title: 'Therapist on Leave',
    description: 'Dr Neha marked leave for tomorrow \u2022 3 appointments affected',
    user_id: null,
    reference_id: 501,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(2),
  },
  {
    id: 29,
    type: 'staff',
    title: 'New Therapist Onboarded',
    description: 'Dr Pooja Singh joined as Occupational Therapist \u2022 Starting Monday',
    user_id: null,
    reference_id: 503,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'normal',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(3),
  },
  {
    id: 30,
    type: 'staff',
    title: 'Schedule Conflict',
    description: 'Dr Amit and Dr Neha both assigned to Room 1 \u2022 Tomorrow 10:00 AM',
    user_id: null,
    reference_id: 504,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'critical',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(3.5),
  },
  {
    id: 31,
    type: 'staff',
    title: 'Overtime Alert',
    description: 'Dr Amit worked 52 hours this week \u2022 Exceeds 45-hour limit',
    user_id: null,
    reference_id: 505,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'high',
    is_read: 0,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(4),
  },

  // ===== READ NOTIFICATIONS (is_read: 1) =====

  // -- Appointments (read) --
  {
    id: 6,
    type: 'appointment',
    title: 'Appointment Cancelled',
    description: 'Riya Patel cancelled OT session \u2022 Tomorrow 11:00 AM',
    user_id: null,
    reference_id: 102,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'high',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(3),
  },
  {
    id: 8,
    type: 'appointment',
    title: 'Patient Arrived',
    description: 'Ankit Kumar arrived for Physiotherapy \u2022 Room 2',
    user_id: null,
    reference_id: 103,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(5),
  },
  {
    id: 12,
    type: 'appointment',
    title: 'Patient Absent',
    description: 'Meera Gupta missed Special Education session \u2022 2nd absence this week',
    user_id: null,
    reference_id: 104,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'high',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(12),
  },
  {
    id: 32,
    type: 'appointment',
    title: 'Session Completed',
    description: 'Aryan Sharma completed Speech Therapy session \u2022 Dr Neha \u2022 Notes added',
    user_id: null,
    reference_id: 110,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(6),
  },
  {
    id: 33,
    type: 'appointment',
    title: 'Bulk Appointments Created',
    description: '8 recurring appointments created for Kavya Nair \u2022 Physiotherapy \u2022 Every Monday',
    user_id: null,
    reference_id: 111,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(8),
  },
  {
    id: 34,
    type: 'appointment',
    title: 'Appointment Reminder Sent',
    description: 'SMS reminders sent to 12 patients for tomorrow\u2019s appointments',
    user_id: null,
    reference_id: 112,
    reference_type: 'appointment',
    link: '/portal/appointment',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(10),
  },

  // -- Payments (read) --
  {
    id: 7,
    type: 'payment',
    title: 'Invoice Overdue',
    description: '\u20B93,000 pending from Sneha Verma \u2022 OT sessions',
    user_id: null,
    reference_id: 202,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(4),
  },
  {
    id: 11,
    type: 'payment',
    title: 'Partial Payment',
    description: '\u20B92,000 of \u20B95,000 received from Riya Patel \u2022 Physiotherapy',
    user_id: null,
    reference_id: 203,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(10),
  },
  {
    id: 35,
    type: 'payment',
    title: '\u20B925,000 Payment Received',
    description: 'Siddharth Joshi \u2022 3-month OT package \u2022 Full payment',
    user_id: null,
    reference_id: 208,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(14),
  },
  {
    id: 36,
    type: 'payment',
    title: 'Invoice Generated',
    description: 'Invoice #INV-2026-089 generated for Tanvi Deshmukh \u2022 \u20B97,500',
    user_id: null,
    reference_id: 209,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(16),
  },
  {
    id: 37,
    type: 'payment',
    title: 'Payment Reminder Sent',
    description: 'Payment reminders sent to 5 patients with overdue invoices',
    user_id: null,
    reference_id: 210,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1),
  },
  {
    id: 38,
    type: 'payment',
    title: 'Discount Applied',
    description: '10% sibling discount applied for Aarav Kulkarni \u2022 Speech Therapy',
    user_id: null,
    reference_id: 211,
    reference_type: 'invoice',
    link: '/portal/invoice',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1.5),
  },

  // -- Waiting List (read) --
  {
    id: 39,
    type: 'waiting_list',
    title: 'Patient Assigned from Waiting List',
    description: 'Meera Gupta assigned to Special Education \u2022 Wednesday 3:00 PM',
    user_id: null,
    reference_id: 305,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(7),
  },
  {
    id: 40,
    type: 'waiting_list',
    title: 'Waiting List Updated',
    description: 'Priya Reddy moved to position #2 on OT waiting list',
    user_id: null,
    reference_id: 306,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(9),
  },
  {
    id: 41,
    type: 'waiting_list',
    title: 'Patient Removed from Waiting List',
    description: 'Ankit Kumar removed from Physiotherapy waiting list \u2022 Patient request',
    user_id: null,
    reference_id: 307,
    reference_type: 'waiting_list',
    link: '/portal/waiting-list',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1),
  },

  // -- Clinical (read) --
  {
    id: 9,
    type: 'clinical',
    title: 'Therapy Progress',
    description: 'Aryan Sharma \u2022 Speech Therapy goal 80% achieved',
    user_id: null,
    reference_id: 402,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(6),
  },
  {
    id: 42,
    type: 'clinical',
    title: 'Treatment Plan Updated',
    description: 'Dr Amit updated Physiotherapy plan for Ankit Kumar \u2022 New goals added',
    user_id: null,
    reference_id: 407,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(8),
  },
  {
    id: 43,
    type: 'clinical',
    title: 'Session Notes Pending',
    description: 'Dr Neha has 4 sessions without clinical notes \u2022 Last 3 days',
    user_id: null,
    reference_id: 408,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'high',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(11),
  },
  {
    id: 44,
    type: 'clinical',
    title: 'Therapy Effectiveness Report',
    description: 'Monthly effectiveness report ready \u2022 Speech Therapy: 78% \u2022 OT: 82% \u2022 Physio: 71%',
    user_id: null,
    reference_id: 409,
    reference_type: 'patient',
    link: '/portal/therapy-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1),
  },
  {
    id: 45,
    type: 'clinical',
    title: 'Dropout Risk Resolved',
    description: 'Riya Patel returned after 2 missed sessions \u2022 Risk level reduced to Low',
    user_id: null,
    reference_id: 410,
    reference_type: 'patient',
    link: '/portal/predictive-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1.5),
  },

  // -- Staff (read) --
  {
    id: 10,
    type: 'staff',
    title: 'Low Utilization',
    description: 'Dr Amit \u2022 40% slot utilization this week',
    user_id: null,
    reference_id: 502,
    reference_type: 'staff',
    link: '/portal/predictive-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(8),
  },
  {
    id: 46,
    type: 'staff',
    title: 'Performance Review Due',
    description: 'Dr Neha \u2022 Quarterly performance review due in 3 days',
    user_id: null,
    reference_id: 506,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: hoursAgo(13),
  },
  {
    id: 47,
    type: 'staff',
    title: 'Certification Expiring',
    description: 'Dr Amit\u2019s Physiotherapy certification expires in 30 days \u2022 Renewal needed',
    user_id: null,
    reference_id: 507,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'high',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(1),
  },
  {
    id: 48,
    type: 'staff',
    title: 'High Utilization',
    description: 'Dr Pooja Singh \u2022 95% slot utilization this week \u2022 Consider adding slots',
    user_id: null,
    reference_id: 508,
    reference_type: 'staff',
    link: '/portal/predictive-intelligence',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(2),
  },
  {
    id: 49,
    type: 'staff',
    title: 'Leave Approved',
    description: 'Dr Amit\u2019s leave approved for next Friday \u2022 2 appointments rescheduled',
    user_id: null,
    reference_id: 509,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(2),
  },
  {
    id: 50,
    type: 'staff',
    title: 'Attendance Alert',
    description: 'Dr Neha late check-in 3 times this week \u2022 Average 22 mins late',
    user_id: null,
    reference_id: 510,
    reference_type: 'staff',
    link: '/portal/employeelist',
    priority: 'normal',
    is_read: 1,
    action_type: null,
    action_data: null,
    clinic_id: 1,
    created_at: daysAgo(3),
  },
];

export const mockNotificationsListResponse = {
  rescode: 1,
  message: 'Notifications fetched successfully',
  data: {
    notifications: mockNotificationsData,
    total: mockNotificationsData.length,
    page: 1,
    totalPages: 1,
  },
};

export const mockUnreadCountResponse = {
  rescode: 1,
  message: 'Unread count fetched',
  data: { count: mockNotificationsData.filter(n => !n.is_read).length },
};

export const mockSmartAlertsResponse = {
  rescode: 1,
  message: 'Smart alerts generated',
  data: [
    {
      type: 'clinical',
      title: 'Dropout Risk',
      description: '3 patients missed 3+ sessions in the last 2 weeks',
      priority: 'critical',
      link: '/portal/predictive-intelligence',
    },
    {
      type: 'appointment',
      title: 'Low Bookings Tomorrow',
      description: 'Only 4 appointments booked \u2022 5 therapy slots empty',
      priority: 'high',
      link: '/portal/appointment',
    },
    {
      type: 'payment',
      title: 'Revenue Declining',
      description: 'Revenue down 15% compared to last week',
      priority: 'high',
      link: '/portal/predictive-intelligence',
    },
    {
      type: 'waiting_list',
      title: 'Waiting List Active',
      description: '5 patients waiting for slots',
      priority: 'normal',
      link: '/portal/waiting-list',
    },
    {
      type: 'staff',
      title: 'Staff Shortage Tomorrow',
      description: '2 therapists on leave \u2022 6 appointments may need rescheduling',
      priority: 'critical',
      link: '/portal/employeelist',
    },
    {
      type: 'clinical',
      title: 'Therapy Stagnation',
      description: '4 patients showing no progress improvement in last 4 weeks',
      priority: 'high',
      link: '/portal/therapy-intelligence',
    },
    {
      type: 'payment',
      title: 'Overdue Invoices',
      description: '\u20B945,000 total overdue from 7 patients \u2022 Oldest: 15 days',
      priority: 'high',
      link: '/portal/invoice',
    },
    {
      type: 'appointment',
      title: 'High No-Show Rate',
      description: '18% no-show rate this week \u2022 Up from 8% last week',
      priority: 'high',
      link: '/portal/predictive-intelligence',
    },
  ],
};
